<template>
    <vs-popup class="gopos-ordr-detail update-price-popup" title="Enter Amount" :active.sync="popupConfig.isOpen">
        <!-- <div class="flex flex-col align-center w-full calculator pl-4 mt-1" v-on:keyup.delete="deleteNum" v-on:keyup="isNumber($event)">
            <div class="w-full position-relative" v-if="current.length >= 1">
                <span class="text-4xl flex justify-center pt-6 pb-5">${{ current }}</span>
            </div>
            <div class="w-full position-relative" v-else>
                <span class="text-4xl flex justify-center pt-6 pb-5">$0</span>
            </div>
            <div class="w-full">
                <calculator-button @append="append" @dot="dot" @deleteNum="deleteNum"></calculator-button>
            </div>
        </div>
        <div class="flex-center mt-5">
            <vs-button class="w-1/3 mr-4" @click="submitResult">OK</vs-button>
            <vs-button type="border" color="danger" class="w-1/3" @click="current = ''">Clear</vs-button>
        </div> -->
        <vs-input v-model="current" class="w-full" v-on:keypress="isNumber($event)"></vs-input>
        <div class="flex-center mt-5">
            <vs-button class="w-1/3" @click="submitResult">OK</vs-button>
        </div>
    </vs-popup>
</template>

<script>
export default {
    name: "update-price-popup",
    props: {
        popupConfig: {
            type: Object,
            required: true
        },
        item_data: {
            type: Object
        },
        isAddPrice: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            current: "",
            // is_change_price: false
        }
    },
    watch: {
        popupConfig: {
            immediate: true,
            deep: true,
            handler() {
                if(this.popupConfig && this.popupConfig.isOpen && this.item_data) {
                    // this.current = this.formatNumber(this.item_data.price);
                    this.current = this.item_data.price || 0;
                }
            }
        }
    },
    methods: {
        // append(number) {
        //     this.inputValue(number);
        // },
        // dot() {
        //     this.inputValue(".");
        // },
        // deleteNum() {
        //     this.inputValue("");
        // },
        // inputValue(value) {
        //     if(value == "." && this.current.toString().indexOf(".") != -1) {
        //         return;
        //     }
        //     if(value == "." && this.current == "") {
        //         this.current = "0";
        //     }
        //     if(value == "") {
        //         this.current = this.current.substring(0, this.current.length - 1);
        //         return;
        //     }
        //     if(value == "0" && this.current == "0") {
        //         return;
        //     }
        //     if(value != "0" && value != "." && value != "" && this.current == "0") {
        //         this.current = "";
        //     }
        //     if(this.current.toString().indexOf(".") == -1 || (this.current.toString().substring(this.current.toString().indexOf(".") + 1)).length != 2) {
        //         this.current = `${this.current}${value}`;
        //     }
        //     console.log(this.current);
        // },
        // formatNumber(value) {
        //     return value ? parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '0';
        //     // return value ? value.toString() : '';
        // },
        // isNumber(evt) {
        //     evt = evt ? evt : window.event;
        //     var charCode = evt.which ? evt.which : evt.keyCode;
        //     if(charCode >= 48 && charCode <= 57) {
        //         this.inputValue(evt.key);
        //         return;
        //     }
        //     if(evt.key == "Backspace") {
        //         this.inputValue("");
        //     }
        //     if(evt.key == ".") {
        //         this.inputValue(".");
        //     }
        // },
        // submitResult() {
        //     if(this.isAddPrice) {
        //         this.$emit("returnPrice", this.current);
        //     } else {
        //         this.$emit("changePrice", { ...this.item_data, new_price: this.current });
        //     }
        // },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && this.current.toString().indexOf(".") != -1) ||
            ((charCode >= 48 && charCode <= 57) && this.current.toString().indexOf(".") != -1 && (this.current.toString().substring(this.current.toString().indexOf(".") + 1)).length == 2)) {
                evt.preventDefault();
            } else {
                if (charCode == 46) {
                    if(this.current == "") {
                        this.current = 0;
                    }
                } else if (this.current === 0 || this.current === '0') {
                    this.current = "";
                }
                return true;
            }
        },
        submitResult() {
            this.$emit("changePrice", { ...this.item_data, new_price: this.current || 0 });
        }
    }
}
</script>

<style lang="scss">
.update-price-popup {
    &.con-vs-popup {
        z-index: 53001;
        .vs-popup {
            width: 400px;
        }
    }
    .calculator {
        // height: calc(100% - 203px); 
        // height: calc(100% - 155px); 
        height: 100%;
        max-height: calc(100vh - 165px);
        overflow: auto;
        .cal-btn-list {
            // width: 276px;
            width: 100%;
            border-top: 1px solid #e5e5e5;
            border-right: 1px solid #e5e5e5;
            .con-btn {
                width: calc(100% / 3) !important;
            }
            .cal-button {
                // width:64px !important; //===> Nut tron ne nha
                // width: 91.5px !important;
                width: 100% !important;
                height: 80px;
                border-radius: 0;
                .vs-button--text {
                    line-height: 0.5;
                }
            }
            .vs-button-custom {
                border-top: none;
                border-right: none;
            }

            .backspace-con {
                // height: 64px; //===> Nut tron ne nha
                height: 80px;
                .backspace-icon {
                    font-size: 1.7rem;
                }
            }

            .btn-staff-code {
                padding-top: 4px;
                padding-bottom: 4px;
            }
        }
        .staff-code-number {
            width: 60px;
            height: 48px;
        }
        
    }
}
</style>